import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserDetailComponent } from '../../user/user-detail/user-detail.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../shared/user.service';
import { TripService } from '../../service/trip.service';
import { Cycle, Payment, Site } from '../../model/trip';
import { ActivatedRoute } from '@angular/router';

@Component({
  providers: [UserDetailComponent],
  selector: 'TripPaymentCardsDetailsVFCancel',
  templateUrl: './TripPaymentCardsDetailsVFCancel.component.html',
  styleUrls: ['./TripPaymentCardsDetailsVFCancel.component.css']
})
export class TripPaymentCardsDetailsVFCancelComponent implements OnInit {

  userDetails: any = null;
  msgs: any[] = [];
  
  constructor(private userService: UserService, private tripService: TripService, private route:ActivatedRoute) { }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;

      let pid:number = this.route.snapshot.params['pid'];
      let catid:number = this.route.snapshot.params['catid'];
      if (catid==0) {catid = null;}
      let sid:number = this.route.snapshot.params['sid'];
      let cid:number = this.route.snapshot.params['cid'];
      if (cid==0) {cid = null;}
      let statusid:number = this.route.snapshot.params['statusid'];
      if (statusid==0) {statusid = null;}
      let grouper:string = this.route.snapshot.params['grouper'];
      if (grouper=='null') {grouper=null;}
      
      let res = {catid: catid, sid:sid, cid: cid, statusid: statusid, grouper: grouper, resCode: '4'};
      sessionStorage.setItem('resCode', JSON.stringify(res));
      //let url = `trip-cycles/${catid}/${sid}/${cid}/${statusid}/${grouper}`
      let url = `trip-cycles-2`;
      window.location.href = url;
      

    },
    (err: HttpErrorResponse) => {
      this.userDetails = null;
      this.showMessage('error', '', 'שגיאה בקבלת הרשאות');
    });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }


  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/tip-card-change/TripPaymentCardsDetailsVFCancel/TripPaymentCardsDetailsVFCancel.component.ts